import * as Immutable from 'immutable';

export interface IPurchaseReportStore {
  subtotal: string
  discount: string
  shipping: string
  taxes: string
  GST: string
  QST: string
  HST: string
  PST_SK: string
  PST_BC: string
  total: string
}

export type PurchaseReportPayload = Partial<IPurchaseReportStore>

const defaultStore = Immutable.Record<IPurchaseReportStore>({
  subtotal: '0.00',
  discount: '0.00',
  shipping: '0.00',
  taxes: '0.00',
  GST: '0.00',
  QST: '0.00',
  HST: '0.00',
  PST_SK: '0.00',
  PST_BC: '0.00',
  total: '0.00',
});

export default class PurchaseReportStore extends defaultStore implements IPurchaseReportStore {}
